import type { ListBuilderList } from '../../../types';
import { createShopStandardColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Previously Purchased list configuration
 * Items previously purchased by the client
 */
export const shopPreviouslyPurchasedList: ListBuilderList = {
	id: 'shop_previously_purchased',
	cacheTTL: 600000,
	name: 'Previously Purchased',
	type: 'default',
	active: true,
	sortOrder: 3,
	columns: createShopStandardColumns(),
	description: 'Items previously purchased by the client',
	defaultSortId: 'in_stock_first',
	requiredFields: SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'previously_purchased',
					label: 'Previously Purchased',
				},
			],
		},
	},
};
